<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex sm6 md4 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<Dropdown
									v-model="location.county_id"
									:error="locationValidation.county_id"
									:ajax="true"
									:data="'counties'"
									:label="'* '+$t('fields.county')"></Dropdown>
							</v-flex>
						</v-layout>
						<v-layout row wrap v-if="showCityDropdown && location.county_id !== null">
							<v-flex xs12>
								<Dropdown v-model="location.city_id"
										  :error="locationValidation.city_id"
										  :ajax="true"
										  :data="'cities/'+location.county_id"
										  :label="'* '+$t('fields.city')"></Dropdown>
							</v-flex>
						</v-layout>
						<v-layout row wrap v-if="showLocationName && location.city_id !== null">
							<v-flex xs12>
								<Autocomplete v-model="location.name"
											  :error="locationValidation.name"
											  :ajax="true"
											  :data="'locations/'+location.city_id"
											  :label="'* '+$t('fields.neighbourhood')"></Autocomplete>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap mt-4 ref="looseFocus">
			<v-flex sm6 xs12>
				<v-card>
					<v-card-text>
						<v-layout v-for="(description, key) in location.descriptions" :key="key" row wrap
								  :class="{'mt-4': key > 0}">
							<v-flex xs12>
								<div class="subheading mb-2">{{description.language_name}}:</div>
								<Editor
									:init="$tinymceInit"
									v-model="description.description"></Editor>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import Location from "../models/Location";
import Autocomplete from "./trinkets/Autocomplete";
import Editor from '@tinymce/tinymce-vue';

export default {
	name: "Location",
	components: {Autocomplete, CheckBox, InputField, Dropdown, Editor},
	data: function () {
		return {
			location: new Location({id: this.$route.params.id}),
			locationValidation: {
				id: '',
				name: '',
				county_id: '',
				city_id: ''
			},
			initialLoad: false,
			changesHappened: false,
			showCityDropdown: true,
			showLocationName: true
		}
	},
	watch: {
		location: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
		"location.county_id": {
			handler: function () {
				this.showCityDropdown = false;
				if (this.initialLoad) {
					this.location.city_id = null;
				}
				this.$nextTick(() => {
					this.showCityDropdown = true;
				});

			},
			deep: true
		},
		"location.city_id": {
			handler: function () {
				this.showLocationName = false;
				if (this.initialLoad) {
					this.location.name = '';
				}
				this.$nextTick(() => {
					this.showLocationName = true;
				});
			},
			deep: true
		}
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			this.$myStore.commit('increaseLoaderCount');
			let vm = this;
			setTimeout(function () {
				let success = true;
				vm.$myStore.commit('decreaseLoaderCount');

				if (vm.location.county_id === null) {
					success = false;
					vm.locationValidation.county_id = vm.$t('alerts.fieldError');
				} else {
					vm.locationValidation.county_id = '';
				}

				if (vm.location.city_id === null) {
					success = false;
					vm.locationValidation.city_id = vm.$t('alerts.fieldError');
				} else {
					vm.locationValidation.city_id = '';
				}

				if (vm.location.name == '') {
					success = false;
					vm.locationValidation.name = vm.$t('alerts.fieldError');
				} else {
					vm.locationValidation.name = '';
				}

				if (success) {
					let action = 'post';
					let addition = '';
					if (vm.location.id != 0) {
						action = 'put';
						addition = '/' + vm.location.id;
					}
					vm.$APICall(action, 'locations' + addition, vm.location, (data, success) => {
						if (success) {
							if (data.success) {
								vm.changesHappened = false;
								if (vm.location.id == 0) {
									vm.$notify(vm.$t('alerts.basicAdd'));
								} else {
									vm.$notify(vm.$t('alerts.basicUpdate'));
								}
								vm.$triggerReload();
								vm.backClick();
							} else {
								vm.$alert(vm.$t('alerts.locationExists'));
							}
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			}, 1000);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		let vm = this;
		if (this.location.id != 0) {
			this.$APICall('get', 'locations/' + this.location.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.locations'), href: '/#/locations', disabled: false},
						{text: vm.location.email, href: '/#/locations/' + vm.location.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					usableData.password_change = false;
					vm.location = usableData;
				}
			});
		} else {
			let payload = {
				pagination: {
					page: 1,
					rowsPerPage: 999999999,
					sortBy: 'name'
				},
				search: {}
			}
			this.$APICall('get', 'languages', payload, (data, success) => {
				if (success) {
					let descriptions = [];
					for (let language of data.items) {
						descriptions.push({
							language_id: language.id,
							language_name: language.name,
							description: ''
						});
					}
					vm.location.descriptions = descriptions;
					vm.initialLoad = true;
				}
			});
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.locations'), href: '/#/locations', disabled: false},
				{text: this.$t('modules.newLocation'), href: '/#/locations/0', disabled: true}
			]);
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
